import { render, staticRenderFns } from "./ElKiosko.vue?vue&type=template&id=832c6ae4&scoped=true"
import script from "./ElKiosko.vue?vue&type=script&lang=js"
export * from "./ElKiosko.vue?vue&type=script&lang=js"
import style0 from "./ElKiosko.vue?vue&type=style&index=0&id=832c6ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832c6ae4",
  null
  
)

export default component.exports